module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="btnBar-btn-container" style="display:inline-block;">\r\n  <button type="button" class="save" data-cy="save" value="save" data-cy="save">'+
((__t=(i18n.t("common:save")))==null?'':__t)+
'</button>\r\n</div>\r\n<div class="btnBar-btn-container" style="display:inline-block;">\r\n  <button type="button" class="revert ui-button-special" data-cy="revert" value="revert" data-cy="revert">'+
((__t=(i18n.t("common:revert")))==null?'':__t)+
'</button>\r\n</div>\r\n&nbsp;&nbsp;&nbsp;\r\n<div class="btnBar-btn-container" style="display:inline-block;">\r\n  <button type="button" class="new ui-button-special" data-cy="new" value="new" data-cy="new">'+
((__t=(i18n.t("common:nw")))==null?'':__t)+
'</button>\r\n</div>\r\n<div class="btnBar-btn-container" style="display:inline-block;">\r\n  <button type="button" class="delete ui-button-special" data-cy="delete" value="delete" data-cy="delete">'+
((__t=(i18n.t("common:del")))==null?'':__t)+
'</button>\r\n</div>\r\n<div class="btnBar-btn-container" style="display:inline-block;">\r\n  <button type="button" class="copy ui-button-special" data-cy="copy" value="copy" data-cy="copy">'+
((__t=(i18n.t("common:copy")))==null?'':__t)+
'</button>\r\n</div>\r\n';
}
return __p;
};
